import { useLocation } from "react-router-dom"
import { IGreenWaveDisplayArgs } from "store/Features/processData/greenWaveDisplay-api-slice"

export const useParseQueryParams = (): IGreenWaveDisplayArgs => {
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)

    const begin: string = queryParams.get("begin") || ""
    const greenBand: boolean = queryParams.get("green_band") === "true";
    const serverId: number | null =
        typeof queryParams.get("server_id") === "string"
            ? parseInt(queryParams.get("server_id") as string)
            : null
    const timeSpan: number | undefined =
        typeof queryParams.get("timespan") === "string"
            ? parseInt(queryParams.get("timespan") as string)
            : undefined

    return {
        serverId,
        begin,
        timespan: timeSpan as number,
        greenBand
    }
}
